<template>
    <div v-if="loading" class="loading-overlay">
    <div class="loading-container">
      <div class="spinner"></div>
      <div class="loading-text mt-1">Seohan</div>
    </div>
  </div>
    <div class="container-fluid py-3 mt-4">
        <div class="">
        <p class="custom-text-h4 font-weight-bold  text-black ma-2">Packing List History</p>
        <p class="font-weight-bold ml-5 mt-0 text-gray">
          <v-icon icon="mdi-sort-reverse-variant" class="mr-2"></v-icon>Order Management >
          Packing List History
        </p>
      </div>

      <div class="search-container mb-4 mt-3">
                <v-row class="d-flex align-items-center">
                    <!-- Invoice 입력 필드 -->
                    <v-col cols="3">

                        <div class="split-box" v-bind="props">
                            <div class="label-box">Invoice No</div>
                            <div class="select-box">
                                <v-text-field
                                v-model="search.invoiceNo"
                                placeholder="Enter Invoice No"
                                dense
                                outlined
                                class="custom-input mt-4"
                                variant="plain"
                            />
                            </div>
                            
                        </div>
                    </v-col>

                    <!-- Date Picker -->
                    <v-col cols="2">

                        <div class="split-box2" v-bind="props">
                            <div class="label-box">Date</div>
                            <div class="select-box">
                                <v-text-field
                                v-model="search.date"
                                type="date"
                                dense
                                outlined
                                class="custom-input mt-4"
                                variant="plain"
                            />
                            />
                            </div>
                            
                        </div>
                    </v-col>

                    <!-- Delivery Location 선택 필드 -->
                    <v-col cols="3">
                        <v-menu offset-y>

                            
                            <template v-slot:activator="{ props }">

                                <div class="split-box3" v-bind="props">
                                    <div class="label-box">Delivery Location</div>
                                    <div class="select-box">
                                        {{ search.deliveryLocation }}
                                    </div>
                                    
                                </div>
                            </template>
                            <v-list>
                                <v-list-item
                                    v-for="(item, index) in locationOptions"
                                    :key="index"
                                    @click="search.deliveryLocation = item"
                                >
                                    <v-list-item-title>{{ item }}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-col>

                    

                    <!-- Status 선택 필드 -->
                    <v-col cols="3">
                        <v-menu offset-y>
                            <template v-slot:activator="{ props }">
                                <div class="split-box4" v-bind="props">
                                    <div class="label-box">Status</div>
                                    <div class="select-box">
                                        {{ search.status }}
                                    </div>
                                </div>
                            </template>
                            <v-list>
                                <v-list-item
                                    v-for="(item, index) in statusOptions"
                                    :key="index"
                                    @click="search.status = item"
                                >
                                    <v-list-item-title>{{ item }}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-col>
                    <!-- Search 버튼 -->
                    <v-col cols="1">
                    <v-btn color="primary" class="mt-4 ml-2 mb-2" @click="applyFilters">
                        <v-icon left>mdi-magnify</v-icon>Search
                    </v-btn>
                    </v-col>

                    <!-- <v-col cols="1">
                        <v-btn color="primary" class="mt-1 ml-7">
                            <v-icon left>mdi-magnify</v-icon> 
                        </v-btn>
                    </v-col> -->
                </v-row>
            </div>

        <v-card class="pa-4 custom-card" elevation="2">

            <div class="d-flex align-items-center mb-3">
            <span class="ml-2 mr-6 font-weight-bold text-muted small">
                * You can reprint the Pallet Label or Packing List, or modify the quantity per pallet.
            </span>
            </div>


            <!-- <div class="d-flex align-items-center mb-3">
                <span class="ml-2 mr-6 font-weight-bold">Search Invoice: </span> 
                <v-text-field 
                    v-model="search" 
                    class="mr-3 search-field custom-width custom-bg" 
                    outlined 
                    dense 
                    variant="outlined">
                </v-text-field>
            </div> -->

            

            <v-data-table 
                :headers="headers" 
                :items-per-page = "9"
                :items="filteredItems" 
                class="elevation-1 custom-table" 
                height="580"
                @click:row="handleRowClick"
                hover
                density="compact">
                <template v-slot:[`item.quantity`]="{ item }">
                    <span style="text-align: right; display: block;">
                        {{ item.quantity.toLocaleString() }}
                    </span>
                </template>
                <template v-slot:[`item.status`]="{ item }">
                    <span
                        :class="{
                        'status-shipping': item.status === 'Shipping',
                        'status-scanning': item.status === 'Scanning',
                        'status-complete': item.status === 'Complete'
                        }"
                    >
                        {{ item.status }}
                    </span>
                </template>

                <template v-slot:[`item.print`]="{ item }">
                    <button class="print-btn" @click="printInvoice(item)">
                        <span class="printer-wrapper">
                            <span class="printer-container">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 92 75">
                                    <path
                                        stroke-width="5"
                                        stroke="black"
                                        d="M12 37.5H80C85.2467 37.5 89.5 41.7533 89.5 47V69C89.5 70.933 87.933 72.5 86 72.5H6C4.067 72.5 2.5 70.933 2.5 69V47C2.5 41.7533 6.75329 37.5 12 37.5Z"
                                    ></path>
                                    <mask fill="white" id="path-2-inside-1_30_7">
                                        <path
                                            d="M12 12C12 5.37258 17.3726 0 24 0H57C70.2548 0 81 10.7452 81 24V29H12V12Z"
                                        ></path>
                                    </mask>
                                    <path
                                        mask="url(#path-2-inside-1_30_7)"
                                        fill="black"
                                        d="M7 12C7 2.61116 14.6112 -5 24 -5H57C73.0163 -5 86 7.98374 86 24H76C76 13.5066 67.4934 5 57 5H24C20.134 5 17 8.13401 17 12H7ZM81 29H12H81ZM7 29V12C7 2.61116 14.6112 -5 24 -5V5C20.134 5 17 8.13401 17 12V29H7ZM57 -5C73.0163 -5 86 7.98374 86 24V29H76V24C76 13.5066 67.4934 5 57 5V-5Z"
                                    ></path>
                                    <circle fill="black" r="3" cy="49" cx="78"></circle>
                                </svg>
                            </span>

                            <span class="printer-page-wrapper">
                                <span class="printer-page"></span>
                            </span>
                        </span>
                        
                    </button>
                </template>



                <template v-slot:[`item.delete`]="{ item }">
                    <button v-if="item.deleteVisible" class="bin-button" @click="deleteInvoice(item)">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 39 7" class="bin-top">
                            <line stroke-width="4" stroke="black" y2="5" x2="39" y1="5"></line>
                            <line stroke-width="3" stroke="black" y2="1.5" x2="26.0357" y1="1.5" x1="12"></line>
                        </svg>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="black" viewBox="0 0 33 39" class="bin-bottom">
                            <mask fill="white" id="path-1-inside-1_8_19">
                                <path d="M0 0H33V35C33 37.2091 31.2091 39 29 39H4C1.79086 39 0 37.2091 0 35V0Z"></path>
                            </mask>
                            <path mask="url(#path-1-inside-1_8_19)" fill="black" d="M0 0H33H0ZM37 35C37 39.4183 33.4183 43 29 43H4C-0.418278 43 -4 39.4183 -4 35H4H29H37ZM4 43C-0.418278 43 -4 39.4183 -4 35V0H4V35V43ZM37 0V35C37 39.4183 33.4183 43 29 43V35V0H37Z"></path>
                            <path stroke-width="4" stroke="black" d="M12 6L12 29"></path>
                            <path stroke-width="4" stroke="black" d="M21 6V29"></path>
                        </svg>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 89 80" class="garbage">
                            <path fill="black" d="M20.5 10.5L37.5 15.5L42.5 11.5L51.5 12.5L68.75 0L72 11.5L79.5 12.5H88.5L87 22L68.75 31.5L75.5066 25L86 26L87 35.5L77.5 48L70.5 49.5L80 50L77.5 71.5L63.5 58.5L53.5 68.5L65.5 70.5L45.5 73L35.5 79.5L28 67L16 63L12 51.5L0 48L16 25L22.5 17L20.5 10.5Z"></path>
                        </svg>
                    </button>
                </template>

            </v-data-table>
        </v-card>
    </div>
    <v-dialog v-model="showPrintModal" max-width="400px" persistent>
    <v-card class="pa-4">
        <!-- Packing List Print 버튼 (임시 보류) -->
        <v-card-title class="text-h6 text-center">
            {{ !['P3009', 'P1309', 'P0809', 'P2004', 'P0200', 'P2016','P2019','P0808'].includes(username?.toUpperCase()) ? 'Packing List Print' : 'Pallet / Packing List Print' }}
        </v-card-title>

        <v-card-actions class="d-flex justify-center">
            
            <!-- Pallet Print 버튼 -->
            <v-btn @click="printPackingList" color="secondary">
                Packing List Print
            </v-btn>
            <v-btn
            v-if="['P3009', 'P1309', 'P0809', 'P2004', 'P0200', 'P2016','P2019','P0808'].includes(username?.toUpperCase())"
            @click="openPalletLabelModal"
            color="primary"
            class="mr-2"
            >
            Pallet Print
            </v-btn>

            
            
        </v-card-actions>
        <v-card-actions class="d-flex justify-center">
            <v-btn color="grey darken-1" @click="closeScreen(); showPrintModal = false"> Close </v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>

<v-dialog v-model="showDetailDialog" max-width="1500px" @update:modelValue="fetchPackingListHistoryDetail">
    <v-card class="pa-4">
        <v-card-title class="text-h6 text-center">
            Packing List History Details
        </v-card-title>
        <v-card-text>
            <!-- ✅ 테이블 추가 -->
            <v-table class="mt-4">
                <thead>
                    <tr>
                        <th>PO Number Detail</th>
                        <th>Part Number</th>
                        <th>Part Name</th>
                        <th style="text-align: right;">Order QTY</th> <!-- ✅ 오른쪽 정렬 -->
                        <th>Destination</th>
                        <th>
                        {{ ['P2016', 'P0200', 'P2019','P0808'].includes(username?.toUpperCase()) ? 'Lot Date' : 'Departure Date' }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in packingListDetails" :key="index">
                        <td style="text-align: center;">{{ item.ASN_NO_DTL }}</td>
                        <td style="text-align: center;">{{ item.ITEM_NO }}</td>
                        <td style="text-align: center;">{{ item.ITEM_NM }}</td>
                        <td style="text-align: right;">{{ item.SHIP_QTY.toLocaleString() }}</td> <!-- ✅ 오른쪽 정렬 및 콤마 추가 -->
                        <td style="text-align: center;">
                            {{ item.CARRIER_NM === "AB" ? "Plant 1 Warehouse" : 
                            item.CARRIER_NM === "BB" ? "Plant 2 Warehouse" :
                            item.CARRIER_NM === "WB" ? "MOBIS RDC" : item.CARRIER_NM }}
                        </td>
                        <td style="text-align: center;">{{ item.PAYER_NM }}</td>
                    </tr>
                </tbody>
            </v-table>
        </v-card-text>

        <v-card-actions class="d-flex justify-center">
            <v-btn color="blue darken-1" @click="triggerPrint"> Print </v-btn>
            <v-btn color="grey darken-1" @click="showDetailDialog = false"> Close </v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>

<!-- ✅ Pallet Label 모달 -->
<v-dialog v-model="showPalletLabelModal" max-width="1300px" persistent>
    <v-card class="pa-4">
        <v-card-title class="text-h6 text-center">
            Pallet Label Details
        </v-card-title>
        <v-card-text>
            <v-table class="pallet-label-table">
                <thead>
                <tr>
                    <th>Part Number</th>
                    <th>Part Name</th>
                    <th>LOT No</th>
                    <th style="text-align: right;">Delivery QTY</th> <!-- ✅ 오른쪽 정렬 -->
                    <th>
                        Per Lack Quantity
                        <br />
                        <small style="font-weight: normal; color: #888;">
                            * Quantity per container can be adjusted if different.
                        </small>
                        </th> 
                    <!-- <th>Rack Type</th> -->
                </tr>
                </thead>
                <tbody>
                <template v-for="(item, index) in palletLabelData" :key="index">
                    <tr>
                        <td class="text-center">{{ item.productNumber }}</td>
                        <td class="text-center">{{ item.productName }}</td>
                        <td class="text-center">{{ item.lotNo }}</td>
                        <td class="text-right" >{{ item.deliveryQty.toLocaleString() }}</td> <!-- ✅ 오른쪽 정렬 및 콤마 추가 -->
                        <td>
                            <input type="number" class="lot-input2 text-right" v-model="item.perContainer" :readonly="isReadOnlyPerContainer || username === 'P2004' || username === 'P0200' || username === 'P2016' || username === 'P2019'|| username === 'P0808'"/>
                        </td>
                        <!-- <td>
                            <select class="lot-input2" v-model="item.rackType">
                                <option value="None">None</option>
                                <option value="Returnable">Returnable</option>
                            </select>
                        </td> -->
                    </tr>
                </template>
                </tbody>
            </v-table>
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
            <v-btn color="primary" @click="handlePalletPrint"> Print(A4 -2) </v-btn>
            <v-btn color="primary" @click="handlePalletPrintLabel"> Print(label) </v-btn>
            <v-btn color="grey darken-1" @click="showPalletLabelModal = false"> Close </v-btn>
        </v-card-actions>
    </v-card>

</v-dialog>
<v-dialog
  v-model="showPackingPreview"
  class="packing-preview-dialog"
  persistent
>
  <v-card>
    <v-card-title class="d-flex justify-space-between align-center">
      <span class="text-h6">Packing List Preview</span>
      <v-btn icon @click="showPackingPreview = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text style="height: calc(100% - 100px); padding: 0 24px;">
      <iframe
        v-if="pdfUrl"
        :src="pdfUrl"
        width="100%"
        height="100%"
        style="border: none;"
      ></iframe>
    </v-card-text>

    <v-card-actions class="d-flex justify-center">
      <v-btn color="grey darken-1" @click="showPackingPreview = false">
        Pallet Print (A4)
      </v-btn>
      <v-btn color="grey darken-1" @click="showPackingPreview = false">
        Pallet Lable Print
      </v-btn>
      <v-btn color="grey darken-1" @click="showPackingPreview = false">
        Close
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>


</template>



<script>
import axios from "axios";
import { mapState } from "vuex";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

if (pdfFonts && pdfFonts.pdfMake) {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
} else {
    console.error("❌ pdfFonts가 로드되지 않았습니다.");
}


export default {

    data() {
        return {
            filteredItems: [], // computed에서 data로 변경
            showPackingPreview: false,
            pdfUrl: null, // Blob URL 저장
            showDetailDialog: false, // ✅ 다이얼로그 표시 여부
            selectedRow: null, // ✅ 선택한 Row의 데이터 저장
            packingListDetails: [],
            search: {
                invoiceNo: "",
                status: "ALL", // 기본값
                deliveryLocation: "ALL", // 기본값
                date: "",
            },
            statusOptions: ["ALL", "Shipping","Scanning" ,"Complete"], // 상태 옵션
            locationOptions: ["ALL", "Plant 1 Warehouse", "Plant 2 Warehouse" , "Plant 1 Develop", "Plant 2 Develop", 'Warehouse'], // 위치 옵션
            headers: [
                { title: "INVOICE NO", key: "invoiceNo", align: "center", sortable: true, headerClass: "bold-header"},
                { title: "Quantity", key: "quantity", align: "center", sortable: false },
                { title: "Issue Date", key: "issueDate", align: "center", sortable: true },
                { title: "Delivery Location", key: "deliveryLocation", align: "center", sortable: true },
                { title: "Status", key: "status", align: "center", sortable: true },
                { title: "Print", key: "print", align: "center", sortable: false },
                { title: "Delete", key: "delete", align: "center", sortable: false },
            ],
            items: [],
            originalData: [],  // ✅ 원본 데이터 저장
            selectedInvoiceData: [], // ✅ 선택된 Invoice의 데이터 저장
            palletLabelData: [], // ✅ Pallet Label에 표시할 데이터
            showPalletLabelModal: false, // ✅ 모달 상태 추가
            showPrintModal: false,
            loading: false,
            originalPerContainer: {},
        };
    },
    computed: {
        isReadOnlyPerContainer() {
            // ✅ 선택된 인보이스의 상태가 Complete(9) 또는 Confirmed(8)인지 여부
            const status = this.selectedInvoiceData[0]?.STATUS_CD;
            return status === '9' || status === '8';
        },
        ...mapState({
            username: (state) => state.username, // Vuex에서 username 가져오기
        }),
    },
    mounted(){
        this.getInvoiceHistory();
    },
    methods: {
        applyFilters() {
            //console.log("🔍 검색 조건:", this.search);

            this.filteredItems = this.items.filter(item => {
            return (
                (this.search.invoiceNo === "" || item.invoiceNo.includes(this.search.invoiceNo)) &&
                (this.search.status === "ALL" || item.status === this.search.status) &&
                (this.search.deliveryLocation === "ALL" || item.deliveryLocation === this.search.deliveryLocation) &&
                (this.search.date === "" || item.issueDate === this.search.date)
            );
            });

            //console.log("✅ After filtering:", this.filteredItems);
        },
        triggerPrint() {

            // ✅ 현재 선택된 invoiceNo 가져오기
            //console.log(this.packingListDetails)
            const invoiceNo = this.packingListDetails[0]?.ASN_NO;
            if (!invoiceNo) {
                console.error("❌ No invoice number found.");
                return;
            }

            // ✅ invoiceNo에 해당하는 아이템 찾기
            const item = this.items.find(i => i.invoiceNo === invoiceNo);
            if (!item) {
                console.error("❌ 해당하는 Invoice 데이터를 찾을 수 없습니다.");
                return;
            }

            // ✅ printInvoice 호출 (리스트의 프린트 버튼 클릭과 동일한 동작)
            this.printInvoice(item);
        },
        async fetchPackingListHistoryDetail() {
            if (!this.selectedRow?.invoiceNo) {
                console.warn("❌ Invoice No가 없습니다.");
                return;
            }

            //console.log(`📡 Fetching Packing List Details for Invoice No: ${this.selectedRow.invoiceNo}`);

            try {
                const response = await axios.post("/api/getPackingListHistoryDetail", {
                    invoiceNo: this.selectedRow.invoiceNo
                });

                if (response.data.success) {
                    this.packingListDetails = response.data.data;
                    //console.log("✅ Packing List Details Loaded:", this.packingListDetails);
                } else {
                    console.error("❌ API 응답 오류:", response.data.message);
                    this.packingListDetails = [];
                }
            } catch (error) {
                console.error("❌ API 요청 실패:", error);
                this.packingListDetails = [];
            }
        },
        handleRowClick(event, { item }) {

            if (
                event.target.closest(".print-btn") ||
                event.target.closest(".bin-button")
            ) {
                //console.log("🚫 Print 또는 Delete 버튼 클릭, handleRowClick 실행 안함");
                return;
            }
            //console.log("📌 선택한 Row:", item);
            this.selectedRow = item; // 선택한 Row 데이터 저장
            this.showDetailDialog = true; // 다이얼로그 열기
            this.fetchPackingListHistoryDetail();
        },
        closeScreen() {
            this.showPrintModal = false;

        },
        async handlePalletPrint() {
            if (this.loading) return; // ✅ 중복 실행 방지
            this.loading = true;

            //console.log("📌 [handlePalletPrint] 실행됨");

            this.isPackingListDisabled = true; 

            // ✅ ASN_NO 확인 (첫 번째 아이템에서 가져오기)
            const asnNo = this.palletLabelData[0]?.asnNo;
            if (!asnNo) {
                console.error("❌ ASN_NO가 없습니다.");
                this.loading = false;
                return;
            }

            //console.log(`📌 [handlePalletPrint] 요청할 ASN_NO: ${asnNo}`);

            let isUpdated = false;
            const updatedData = [];

            // ✅ `Per Container` 값이 0 이하인지 검사
            for (const item of this.palletLabelData) {
                if (!item.perContainer || Number(item.perContainer) <= 0) {
                    alert(`🚨 Error: PO Detail: ${item.poDetail}, Lot No: ${item.lotNo} - "Per Container" cannot be 0 or below. Please enter a valid number.`);
                    this.loading = false;
                    return;
                }
            }
             // ✅ `this.originalData`에서 `Per Container`의 원래 값 가져와서 비교
             this.palletLabelData.forEach(item => {
                if (item.rackType === 'None') {
                    item.rackType = '';
                }
                const originalItem = this.originalData.find(data => data.ASN_NO_DTL === item.asnNoDtl);
                const originalPerContainer = originalItem ? originalItem.PAL_AMT : null;
                const originalRackType = originalItem ? originalItem.RACK_TYPE : null;
                //console.log(originalRackType, item.rackType)
                if (originalPerContainer !== item.perContainer || originalRackType !== item.rackType) {
                    isUpdated = true;
                    updatedData.push({
                        asnNoDtl: item.asnNoDtl,
                        perContainer: item.perContainer,
                        rackType: item.rackType
                    });
                }
            });
            if (isUpdated) {
                const userConfirmed = confirm("Did you update the paller quantity? or Rack Type?");
                if(!userConfirmed){
                    //console.log("user canceled the update")
                    this.loading = false;
                    return;
                }
                try {
                    //console.log("🔄 Per Container 값 변경됨. 업데이트 API 호출");
                    const palletUpdateData = updatedData.map(updatedItem => {
                        const matchedItem = this.palletLabelData.find(item => item.asnNoDtl === updatedItem.asnNoDtl);

                        if (matchedItem) {
                            const deliveryQty = matchedItem.deliveryQty;
                            const perContainer = matchedItem.perContainer;
                            const rackType = matchedItem.rackType === 'None' ? '' : matchedItem.rackType;

                            // PAL_QTY 계산
                            const PAL_QTY = Math.ceil(deliveryQty / perContainer);

                            return {
                                asnNoDtl: updatedItem.asnNoDtl,
                                PAL_QTY,
                                rackType,
                                perContainer
                            };
                        }
                    }).filter(Boolean); // null, undefined 제거
                    //console.log("✅ API 전송 데이터:", palletUpdateData);
                    const updateResponse = await axios.post("/api/updatePalletQty", {
                        data: palletUpdateData
                    });

                    if (updateResponse.data.success) {
                        //console.log("✅ Per Container 업데이트 성공");
                         // 🔽 Mat Packing Info 업데이트 호출
                         try {
                            const matPackingInfoData = [];

                            this.palletLabelData.forEach(item => {
                                let remainingQty = item.deliveryQty;
                                const perContainer = item.perContainer || 1; // perContainer가 0이 되지 않도록

                                while (remainingQty > 0) {
                                    matPackingInfoData.push({
                                        Part_number: item.productNumber,
                                        Part_name: item.productName,
                                        quantity: Math.min(perContainer, remainingQty), // perContainer 단위로 쪼갬
                                        lotDate: item.lotNo, // lotCode가 날짜라면 그대로 사용, 아니면 확인 필요
                                        lotNo: item.lotCode,
                                        SupplierName: item.cust_nm,
                                        SupplierCode: `${item.cust_cd} / ${item.cust_nm}`,
                                        CUST_CD: item.cust_cd,
                                        po_no_dtl: item.poDetail,
                                        ASN_NO: item.asnNo
                                    });

                                    remainingQty -= perContainer;
                                }
                            });

                            //console.log("📦 Mat Packing Info 데이터:", matPackingInfoData);

                            const matPackingResponse = await axios.post("/api/insertMatPackingInfo2", {
                                data: matPackingInfoData
                            });

                            if (matPackingResponse.data.success) {
                                //console.log("✅ Mat Packing Info 업데이트 성공");
                            } else {
                                console.error("❌ Mat Packing Info 업데이트 실패:", matPackingResponse.data.message);
                            }
                        } catch (error) {
                            console.error("❌ Mat Packing Info 업데이트 API 호출 실패:", error);
                        }
                        
                    } else {
                        console.error("❌ Per Container 업데이트 실패:", updateResponse.data.message);
                        this.loading = false;
                        return;
                    }
                } catch (error) {
                    console.error("❌ Per Container 업데이트 API 호출 실패:", error);
                    this.loading = false;
                    return;
                }
            } else {
                //console.log("✅ Per Container 값 변경 없음, 바로 진행");
            }


            // ✅ API 중복 호출 방지를 위해 먼저 `pdfDetails` 초기화
            this.pdfDetails = [];

            try {
                // ✅ API 먼저 호출 (이제 `generatePdf()`에서 호출하지 않음)
                let response;

                if (this.username === 'P2004' || this.username === 'P0200' || this.username === 'P2016'|| this.username === 'P2019'|| this.username === 'P0808') {
                    response = await axios.post("/api/getInfoPackingHistoryPrintPalletLabelFromBarcodeHis", { asnNo });
                } else {
                    response = await axios.post("/api/getInfoPackingHistoryPrintPalletLabel", { asnNo });
                }
                if (response.data.success) {
                    if (response.data.data.length === 0) {
                        console.warn("⚠ No data received. Cannot proceed with printing.");
                        alert("오류가 생겨 프린트를 할 수 없습니다."); // ✅ 사용자에게 메시지 출력
                        this.loading = false;
                        this.showPalletLabelModal = false;
                        return;
                    }

                    //console.log("✅ [handlePalletPrint] API 호출 성공:", response.data.data);

                    // ✅ API 응답 데이터를 `pdfDetails`에 저장
                    this.pdfDetails = response.data.data.map(item => {
                        let formattedPartNumber = item.ITMNO.trim();

                        if (!isNaN(parseFloat(formattedPartNumber.charAt(0))) && isFinite(formattedPartNumber.charAt(0))) {
                            formattedPartNumber = formattedPartNumber.substring(0, 5) + '-' + formattedPartNumber.substring(5);
                        } else {
                            formattedPartNumber = formattedPartNumber.substring(0, 6) + '-' + formattedPartNumber.substring(6);
                        }

                        let formattedLotDate = item.BOX_LOT;
                        if (formattedLotDate && formattedLotDate.length === 8) {
                            formattedLotDate = `${formattedLotDate.substring(0, 4)}-${formattedLotDate.substring(4, 6)}-${formattedLotDate.substring(6, 8)}`;
                        }

                        return {
                            Part_number: formattedPartNumber, // ✅ 변환된 Part Number 적용
                            Part_name: item.ITM_NM,
                            quantity: item.BOX1_QTY,
                            lotDate: formattedLotDate,
                            SupplierName: item.CUST_NM,
                            SupplierCode: item.CUST_CD,
                            handlingUnit: item.BOX_QR,
                            box1Qr: item.BOX1_QR || "",
                            copies: item.COPIES
                        };
                    });


                    // console.log("📌 [handlePalletPrint] PDF 생성 데이터:", this.pdfDetails);

                    // ✅ API 호출 후 `generatePdf()` 실행
                    this.showPalletLabelModal = false;
                    this.generatePdf();
                } else {
                    console.error("❌ [handlePalletPrint] API 응답 오류:", response.data.message);
                }
            } catch (error) {
                console.error("❌ [handlePalletPrint] API 호출 실패:", error);
            } finally {
                this.showPalletLabelModal = false;
                this.loading = false;
            }
        },

        async handlePalletPrintLabel() {
            if (this.loading) return; // ✅ 중복 실행 방지
            this.loading = true;

            //console.log("📌 [handlePalletPrint] 실행됨");

            this.isPackingListDisabled = true; 

            // ✅ ASN_NO 확인 (첫 번째 아이템에서 가져오기)
            const asnNo = this.palletLabelData[0]?.asnNo;
            if (!asnNo) {
                console.error("❌ ASN_NO가 없습니다.");
                this.loading = false;
                return;
            }

            //console.log(`📌 [handlePalletPrint] 요청할 ASN_NO: ${asnNo}`);

            let isUpdated = false;
            const updatedData = [];

            // ✅ `Per Container` 값이 0 이하인지 검사
            for (const item of this.palletLabelData) {
                if (!item.perContainer || Number(item.perContainer) <= 0) {
                    alert(`🚨 Error: PO Detail: ${item.poDetail}, Lot No: ${item.lotNo} - "Per Container" cannot be 0 or below. Please enter a valid number.`);
                    this.loading = false;
                    return;
                }
            }
             // ✅ `this.originalData`에서 `Per Container`의 원래 값 가져와서 비교
             this.palletLabelData.forEach(item => {
                if (item.rackType === 'None') {
                    item.rackType = '';
                }
                const originalItem = this.originalData.find(data => data.ASN_NO_DTL === item.asnNoDtl);
                const originalPerContainer = originalItem ? originalItem.PAL_AMT : null;
                const originalRackType = originalItem ? originalItem.RACK_TYPE : null;
                if (originalPerContainer !== item.perContainer || originalRackType !== item.rackType) {
                    isUpdated = true;
                    updatedData.push({
                        asnNoDtl: item.asnNoDtl,
                        perContainer: item.perContainer,
                        rackType: item.rackType
                    });
                }
            });
            if (isUpdated) {
                const userConfirmed = confirm("Did you update the paller quantity? or Rack Type?");
                if(!userConfirmed){
                    //console.log("user canceled the update")
                    this.loading = false;
                    return;
                }
                try {
                    //console.log("🔄 Per Container 값 변경됨. 업데이트 API 호출");
                    const palletUpdateData = updatedData.map(updatedItem => {
                        const matchedItem = this.palletLabelData.find(item => item.asnNoDtl === updatedItem.asnNoDtl);

                        if (matchedItem) {
                            const deliveryQty = matchedItem.deliveryQty;
                            const perContainer = matchedItem.perContainer;
                            const rackType = matchedItem.rackType === 'None' ? '' : matchedItem.rackType;

                            // PAL_QTY 계산
                            const PAL_QTY = Math.ceil(deliveryQty / perContainer);

                            return {
                                asnNoDtl: updatedItem.asnNoDtl,
                                PAL_QTY,
                                rackType,
                                perContainer
                            };
                        }
                    }).filter(Boolean); // null, undefined 제거
                    //console.log("✅ API 전송 데이터:", palletUpdateData);
                    //console.log(this.palletLabelData)
                    const updateResponse = await axios.post("/api/updatePalletQty", {
                        data: palletUpdateData
                    });

                    if (updateResponse.data.success) {
                        //console.log("✅ Per Container 업데이트 성공");
                         // 🔽 Mat Packing Info 업데이트 호출
                         try {
                            const matPackingInfoData = [];

                            this.palletLabelData.forEach(item => {
                                let remainingQty = item.deliveryQty;
                                const perContainer = item.perContainer || 1; // perContainer가 0이 되지 않도록

                                while (remainingQty > 0) {
                                    matPackingInfoData.push({
                                        Part_number: item.productNumber,
                                        Part_name: item.productName,
                                        quantity: Math.min(perContainer, remainingQty), // perContainer 단위로 쪼갬
                                        lotDate: item.lotNo, // lotCode가 날짜라면 그대로 사용, 아니면 확인 필요
                                        lotNo: item.lotCode,
                                        SupplierName: item.cust_nm,
                                        SupplierCode: `${item.cust_cd} / ${item.cust_nm}`,
                                        CUST_CD: item.cust_cd,
                                        po_no_dtl: item.poDetail,
                                        ASN_NO: item.asnNo
                                    });

                                    remainingQty -= perContainer;
                                }
                            });

                            //console.log("📦 Mat Packing Info 데이터:", matPackingInfoData);

                            const matPackingResponse = await axios.post("/api/insertMatPackingInfo2", {
                                data: matPackingInfoData
                            });

                            if (matPackingResponse.data.success) {
                                //console.log("✅ Mat Packing Info 업데이트 성공");
                            } else {
                                console.error("❌ Mat Packing Info 업데이트 실패:", matPackingResponse.data.message);
                            }
                        } catch (error) {
                            console.error("❌ Mat Packing Info 업데이트 API 호출 실패:", error);
                        }
                        
                    } else {
                        console.error("❌ Per Container 업데이트 실패:", updateResponse.data.message);
                        this.loading = false;
                        return;
                    }
                } catch (error) {
                    console.error("❌ Per Container 업데이트 API 호출 실패:", error);
                    this.loading = false;
                    return;
                }
            } else {
                //console.log("✅ Per Container 값 변경 없음, 바로 진행");
            }


            // ✅ API 중복 호출 방지를 위해 먼저 `pdfDetails` 초기화
            this.pdfDetails = [];

            try {
                // ✅ API 먼저 호출 (이제 `generatePdf()`에서 호출하지 않음)
                let response;

                if (this.username === 'P2004'|| this.username === 'P0200' || this.username === 'P2016'|| this.username === 'P2019'|| this.username === 'P0808') {
                    response = await axios.post("/api/getInfoPackingHistoryPrintPalletLabelFromBarcodeHis", { asnNo });
                } else {
                    response = await axios.post("/api/getInfoPackingHistoryPrintPalletLabel", { asnNo });
                }

                if (response.data.success) {
                    if (response.data.data.length === 0) {
                        console.warn("⚠ No data received. Cannot proceed with printing.");
                        alert("오류가 생겨 프린트를 할 수 없습니다."); // ✅ 사용자에게 메시지 출력
                        this.loading = false;
                        this.showPalletLabelModal = false;
                        return;
                    }

                    //console.log("✅ [handlePalletPrint] API 호출 성공:", response.data.data);

                    // ✅ API 응답 데이터를 `pdfDetails`에 저장
                    this.pdfDetails = response.data.data.map(item => {
                        let formattedPartNumber = item.ITMNO.trim();

                        if (!isNaN(parseFloat(formattedPartNumber.charAt(0))) && isFinite(formattedPartNumber.charAt(0))) {
                            formattedPartNumber = formattedPartNumber.substring(0, 5) + '-' + formattedPartNumber.substring(5);
                        } else {
                            formattedPartNumber = formattedPartNumber.substring(0, 6) + '-' + formattedPartNumber.substring(6);
                        }

                        let formattedLotDate = item.BOX_LOT;
                        if (formattedLotDate && formattedLotDate.length === 8) {
                            formattedLotDate = `${formattedLotDate.substring(0, 4)}-${formattedLotDate.substring(4, 6)}-${formattedLotDate.substring(6, 8)}`;
                        }

                        return {
                            Part_number: formattedPartNumber, // ✅ 변환된 Part Number 적용
                            Part_name: item.ITM_NM,
                            quantity: item.BOX1_QTY,
                            lotDate: formattedLotDate,
                            SupplierName: item.CUST_NM,
                            SupplierCode: item.CUST_CD,
                            handlingUnit: item.BOX_QR,
                            box1Qr: item.BOX1_QR || "",
                            copies: item.COPIES
                        };
                    });


                    //console.log("📌 [handlePalletPrint] PDF 생성 데이터:", this.pdfDetails);

                    // ✅ API 호출 후 `generatePdf()` 실행
                    this.showPalletLabelModal = false;
                    this.generatePdf2();
                } else {
                    console.error("❌ [handlePalletPrint] API 응답 오류:", response.data.message);
                }
            } catch (error) {
                console.error("❌ [handlePalletPrint] API 호출 실패:", error);
            } finally {
                this.showPalletLabelModal = false;
                this.loading = false;
            }
        },

        async generateBarcode(text) {
            this.loading = true;

            try {
                if (!text) {
                    console.warn("⚠️ 바코드 데이터가 없습니다.");
                    return null;
                }

                //console.log("📌 바코드 생성 요청 중:", text);

                const response = await axios.post("/api/generateBarcode", { text });

                if (response.data.success) {
                    //console.log("✅ 바코드 생성 성공");
                    return response.data.barcode; // ✅ Base64 이미지 반환
                } else {
                    console.error("❌ 바코드 생성 실패:", response.data.message);
                    this.loading = false;

                    return null;
                }
            } catch (error) {
                console.error("❌ API 요청 중 오류 발생:", error);
                this.loading = false;

                return null;
            }
        },
        async generatePdf() {
            //console.log("📌 PDF 생성 시작");

            const barcodePromises = this.pdfDetails.map(async (detail) => {
                if (detail.box1Qr) {
                    const barcode = await this.generateBarcode(detail.box1Qr);
                    detail.barcodeImage = barcode; // ✅ 바코드 이미지 저장
                } else {
                    detail.barcodeImage = null; // ✅ 바코드 없을 경우 null
                }
            });
            // console.log('A4size' , this.pdfDetails)
            // ✅ 모든 바코드 생성이 완료될 때까지 기다림
            await Promise.all(barcodePromises);
            try {
                // ✅ 백엔드에 PDF 생성 요청
                const response = await axios.post(
                    "/api/createPalletLabelPdf2",
                    { pdfDetails: this.pdfDetails },
                    { responseType: "blob" }
                );

                if (response.status === 200) {
                    const file = new Blob([response.data], { type: "application/pdf" });
                    const fileURL = URL.createObjectURL(file);

                    const newWindow = window.open("", "_blank", "width=1200,height=900,left=200,top=100");

                    if (newWindow) {
                        newWindow.document.write(`
                        <html>
                            <head>
                            <title>Pallet Label Preview</title>
                            <style>
                                body {
                                margin: 0;
                                display: flex;
                                flex-direction: column;
                                height: 100vh;
                                }
                                iframe {
                                flex: 1;
                                border: none;
                                width: 100%;
                                }
                                button {
                                padding: 10px 20px;
                                font-size: 16px;
                                font-weight: bold;
                                background-color: #007bff;
                                color: white;
                                border: none;
                                cursor: pointer;
                                margin: 10px;
                                }
                            </style>
                            </head>
                            <body>
                            <iframe src="${fileURL}"></iframe>
                            </body>
                        </html>
                        `);
                    } else {
                        alert("팝업 차단으로 인해 새 창을 열 수 없습니다.");
                    }

                    this.isPackingListDisabled = false;
                    this.isPalletPrintDisabled = true;
                    this.showPalletLabelModal = false;
                } else {
                    console.error("❌ PDF 생성 실패:", response.status);
                }
            } catch (error) {
                console.error("❌ PDF 생성 API 호출 실패:", error);
            }
            // const docDefinition = {
            //     content: this.pdfDetails.map((detail, index, array) => {
            //         // ✅ box1Qr 값에서 :3S 뒤와 :V 사이 값 추출
                    
            //         //console.log("📌 PDF 생성 시작2");

            //         return {
            //             stack: [
            //                 {
            //                     canvas: [
            //                         { type: "rect", x: 0, y: 0, w: 520, h: 350, r: 5, lineColor: "black" }, // ✅ 라벨 테두리
            //                         { type: "line", x1: 10, y1: 100, x2: 510, y2: 100, lineWidth: 1 }, // ✅ 구분선 1
            //                         { type: "line", x1: 10, y1: 160, x2: 510, y2: 160, lineWidth: 1 }, // ✅ 구분선 2
            //                         { type: "line", x1: 10, y1: 220, x2: 510, y2: 220, lineWidth: 1 }, // ✅ 구분선 3
            //                         { type: "line", x1: 10, y1: 280, x2: 200, y2: 280, lineWidth: 1 }, // ✅ 구분선 4
            //                         { type: "line", x1: 250, y1: 160, x2: 250, y2: 220, lineWidth: 1 }, // ✅ 구분선 5
            //                         { type: "line", x1: 200, y1: 220, x2: 200, y2: 340, lineWidth: 1 }, // ✅ 구분선 6
                                
            //                         { type: "rect", x: 0, y: 375, w: 520, h: 350, r: 5, lineColor: "black" }, // ✅ 라벨 테두리
            //                         { type: "line", x1: 10, y1: 475, x2: 510, y2: 475, lineWidth: 1 }, // ✅ 구분선 1
            //                         { type: "line", x1: 10, y1: 535, x2: 510, y2: 535, lineWidth: 1 }, // ✅ 구분선 2
            //                         { type: "line", x1: 10, y1: 595, x2: 510, y2: 595, lineWidth: 1 }, // ✅ 구분선 3
            //                         { type: "line", x1: 10, y1: 655, x2: 200, y2: 655, lineWidth: 1 }, // ✅ 구분선 4
            //                         { type: "line", x1: 250, y1: 535, x2: 250, y2: 595, lineWidth: 1 }, // ✅ 구분선 5
            //                         { type: "line", x1: 200, y1: 595, x2: 200, y2: 715, lineWidth: 1 }, // ✅ 구분선 6
            //                     ]
            //                 },
            //                 { text: "Part Number", fontSize: 12, bold: true, absolutePosition: { x: 50, y: 50 } },
            //                 { text: detail.Part_number, fontSize: 45, bold: true, absolutePosition: { x: 150, y: 70 } },

            //                 { text: "Description", fontSize: 12, bold: true, absolutePosition: { x: 50, y: 150 } },
            //                 { text: detail.Part_name, fontSize: 33, absolutePosition: { x: 130, y: 148 } },

            //                 { text: "Supplier", fontSize: 12, bold: true, absolutePosition: { x: 50, y: 210 } },
            //                 { text: detail.SupplierName, fontSize: 13, bold: true, absolutePosition: { x: 110, y: 230 } },

            //                 { text: "Handling Unit", fontSize: 12, bold: true, absolutePosition: { x: 300, y: 210 } },
            //                 { text: detail.handlingUnit, fontSize: 12, bold: true, absolutePosition: { x: 360, y: 235 } }, // ✅ box1Qr에서 추출한 값 삽입

            //                 { text: "Quantity", fontSize: 12, bold: true, absolutePosition: { x: 50, y: 270 } },
            //                 { text: detail.quantity, fontSize: 15, bold: true, absolutePosition: { x: 120, y: 290 } },

            //                 { text: "Manufactured Date", fontSize: 12, bold: true, absolutePosition: { x: 50, y: 330 } },
            //                 { text: detail.lotDate, fontSize: 15, bold: true, absolutePosition: { x: 120, y: 350 } },

            //                 { text: "Broadcast Code", fontSize: 12, bold: true, absolutePosition: { x: 250, y: 270 } },
            //                 {
            //                     image: detail.barcodeImage, // ✅ 생성된 바코드 이미지 적용
            //                     width: 300,
            //                     height: 80,
            //                     absolutePosition: { x: 250, y: 300 }
            //                 },

            //                 { text: "Part Number", fontSize: 12, bold: true, absolutePosition: { x: 50, y: 425 } },
            //                 { text: detail.Part_number, fontSize: 45, bold: true, absolutePosition: { x: 150, y: 445 } },

            //                 { text: "Description", fontSize: 12, bold: true, absolutePosition: { x: 50, y: 525 } },
            //                 { text: detail.Part_name, fontSize: 33, absolutePosition: { x: 130, y: 523 } },

            //                 { text: "Supplier", fontSize: 12, bold: true, absolutePosition: { x: 50, y: 585 } },
            //                 { text: detail.SupplierName, fontSize: 13, bold: true, absolutePosition: { x: 110, y: 605 } },

            //                 { text: "Handling Unit", fontSize: 12, bold: true, absolutePosition: { x: 300, y: 585 } },
            //                 { text: detail.handlingUnit, fontSize: 12, bold: true, absolutePosition: { x: 360, y: 610 } }, // ✅ box1Qr에서 추출한 값 삽입

            //                 { text: "Quantity", fontSize: 12, bold: true, absolutePosition: { x: 50, y: 645 } },
            //                 { text: detail.quantity, fontSize: 15, bold: true, absolutePosition: { x: 120, y: 665 } },

            //                 { text: "Manufactured Date", fontSize: 12, bold: true, absolutePosition: { x: 50, y: 705 } },
            //                 { text: detail.lotDate, fontSize: 15, bold: true, absolutePosition: { x: 120, y: 725 } },

            //                 { text: "Broadcast Code", fontSize: 12, bold: true, absolutePosition: { x: 250, y: 645 } },
            //                 {
            //                     image: detail.barcodeImage, // ✅ 생성된 바코드 이미지 적용
            //                     width: 300,
            //                     height: 80,
            //                     absolutePosition: { x: 250, y: 675 }
            //                 }

            //             ],
            //             pageBreak: index < array.length - 1 ? 'after' : undefined 
            //         };
            //     }),
            //     defaultStyle: {
            //         fontSize: 12
            //     }
            // };

            // try {
            //     // ✅ PDF 미리보기 (다운로드X, 새 창에서 열기)
            //     pdfMake.createPdf(docDefinition).open();
            //     this.isPackingListDisabled = false;  // Packing List Print 활성화
            //     this.isPalletPrintDisabled = true; 
            //     this.showPalletLabelModal = false;
            // } catch (error) {
            //     console.error("❌ PDF 미리보기 중 오류 발생:", error);
            // }
        },

        async generatePdf2() {
            //console.log("📌 PDF 생성 시작");

            const barcodePromises = this.pdfDetails.map(async (detail) => {
                if (detail.box1Qr) {
                    const barcode = await this.generateBarcode(detail.box1Qr);
                    detail.barcodeImage = barcode; // ✅ 바코드 이미지 저장
                } else {
                    detail.barcodeImage = null; // ✅ 바코드 없을 경우 null
                }
            });

            // ✅ 모든 바코드 생성이 완료될 때까지 기다림
            await Promise.all(barcodePromises);
            try {
                const isShinwha = this.username === "P0200";
                const apiUrl = isShinwha
                ? "/api/createPalletLabelPdfForshinwhaNewVersion"
                : "/api/createPalletLabelPdf3";

                const response = await axios.post(
                apiUrl,
                { pdfDetails: this.pdfDetails },
                { responseType: "blob" }
                );
                if (response.status === 200) {
                    const file = new Blob([response.data], { type: "application/pdf" });
                    const reader = new FileReader();
                    reader.readAsArrayBuffer(file);
                    reader.onload = async () => {
                        const { PDFDocument, degrees } = await import("pdf-lib"); // ✅ pdf-lib 동적 로드
                        const pdfDoc = await PDFDocument.load(reader.result);
                        const pages = pdfDoc.getPages();

                        // ✅ 모든 페이지를 90도 회전
                        if (!isShinwha) {
                            pages.forEach((page) => {
                                page.setRotation(degrees(90));
                            });
                        }
                        // ✅ 새로운 PDF 생성
                        const rotatedPdfBytes = await pdfDoc.save();
                        const rotatedFile = new Blob([rotatedPdfBytes], { type: "application/pdf" });
                        const rotatedFileURL = URL.createObjectURL(rotatedFile);

                        const newWindow = window.open("", "_blank", "width=1200,height=900,left=200,top=100");
                        if (newWindow) {
                            newWindow.document.write(`
                                <html>
                                <head>
                                    <title>Pallet Label Rotated</title>
                                    <style>
                                    body {
                                        margin: 0;
                                        display: flex;
                                        flex-direction: column;
                                        height: 100vh;
                                    }
                                    iframe {
                                        flex: 1;
                                        border: none;
                                        width: 100%;
                                    }
                                    button {
                                        padding: 10px 20px;
                                        font-size: 16px;
                                        font-weight: bold;
                                        background-color: #28a745;
                                        color: white;
                                        border: none;
                                        cursor: pointer;
                                        margin: 10px;
                                    }
                                    </style>
                                </head>
                                <body>
                                    <iframe src="${rotatedFileURL}"></iframe>
                                </body>
                                </html>
                            `);
                            } else {
                            alert("팝업 차단으로 인해 새 창을 열 수 없습니다.");
                            }
                    };
                    this.isPackingListDisabled = false;
                    this.isPalletPrintDisabled = true;
                    this.showPalletLabelModal = false;
                } else {
                    console.error("❌ PDF 생성 실패:", response.status);
                }
            } catch (error) {
                console.error("❌ PDF 생성 API 호출 실패:", error);
            }
        },
        async getInfoPackingHistoryPrintPalletLabel() {
            this.loading = true;
            //console.log(this.palletLabelData)
            try {
                //console.log("📌 ASN_NO_DTL 기반 데이터 요청 시작");

                // ✅ 현재 palletLabelData에서 ASN_NO_DTL 목록 가져오기
                const asnNo = this.palletLabelData[0]?.asnNo;
                if (!asnNo) {
                    console.error("❌ ASN_NO가 없습니다.");
                    this.loading = false;
                    return;
                }
                // ✅ API 호출
                const response = await axios.post("/api/getInfoPackingHistoryPrintPalletLabel", {
                    asnNo, // ✅ 배열로 전달
                });

                this.pdfDetails = [];

                if (response.data.success) {
                    if (response.data.data.length === 0) {
                        console.warn("⚠ No data received. Cannot proceed with printing.");
                        alert("오류가 생겨 프린트를 할 수 없습니다."); // ✅ 사용자에게 메시지 출력
                        return; // ✅ 중단
                    }

                    //console.log("✅ API 호출 성공:", response.data.data);

                    // ✅ API 응답 데이터를 `pdfDetails`에 저장
                    this.pdfDetails = response.data.data.map(item => ({
                        Part_number: item.ITEM_NO,
                        Part_name: item.ITEM_NM,
                        quantity: item.SHIP_QTY,
                        lotDate: item.LOT_DATE,
                        lotNo: item.PAYER_NM,
                        SupplierName: item.SUPPLIER_NM,
                        SupplierCode: item.SUPPLIER_CD,
                        CUST_CD: item.CUSTOMER_CD,
                        po_no_dtl: item.ASN_NO_DTL,
                        ASN_NO: item.ASN_NO,
                        box1Qr: item.BOX1_QR || "",
                    }));

                    //console.log("📌 PDF 생성 데이터:", this.pdfDetails);

                    // ✅ PDF 생성 실행
                    this.generatePdf();
                } else {
                    console.error("❌ API 응답 오류:", response.data.message);
                }
            } catch (error) {
                console.error("❌ API 호출 실패:", error);
            } finally {
                this.loading = false;
            }
        },

        async openPalletLabelModal() {
            try {
                this.loading = true;

                // ✅ 최신 데이터 조회
                const response = await axios.get("/api/getInvoiceHistory", {
                    params: { username: this.username },
                });

                if (response.data.success) {
                    // ✅ 최신 originalData 갱신
                    this.originalData = response.data.invoiceHistory;

                    // ✅ 해당 ASN_NO로 필터링해서 selectedInvoiceData 갱신
                    const targetAsnNo = this.selectedInvoiceData[0]?.ASN_NO;
                    this.selectedInvoiceData = this.originalData.filter(item => item.ASN_NO === targetAsnNo);

                    // ✅ 최신 selectedInvoiceData 기준으로 palletLabelData 세팅
                    this.palletLabelData = this.selectedInvoiceData.map(item => {
                        const perContainer = item.PAL_AMT || 1;
                        this.originalPerContainer[item.ASN_NO_DTL] = perContainer;

                        return {
                            cust_cd: item.CUST_CD,
                            cust_nm: item.CUST_NM,
                            poDetail: item.PO_NO_DTL,
                            asnNo: item.ASN_NO,
                            asnNoDtl: item.ASN_NO_DTL,
                            productNumber: item.ITEM_NO,
                            productName: item.ITEM_NM,
                            lotCode: item.CONT_NO,
                            lotNo: item.PAYER_NM,
                            deliveryQty: item.SHIP_QTY,
                            perContainer: perContainer,
                            rackType: item.RACK_TYPE ? item.RACK_TYPE : "None",
                        };
                    });

                    this.showPalletLabelModal = true;
                    //console.log("📦 Pallet Label Modal Opened with latest data!");
                } else {
                    console.error("❌ 최신 데이터 조회 실패:", response.data.message);
                    alert("최신 데이터를 가져오지 못했습니다.");
                }
            } catch (error) {
                console.error("❌ 최신 데이터 조회 오류:", error);
                alert("데이터를 불러오는 중 오류가 발생했습니다.");
            } finally {
                this.loading = false;
            }
        },
        // ✅ 날짜 포맷 변경 함수 (20250227 → 2025-02-27)
        
        formatDate(dateString) {
            if (!dateString || dateString.length !== 8) return "Invalid Date";
            return `${dateString.substring(0, 4)}-${dateString.substring(4, 6)}-${dateString.substring(6, 8)}`;
        },

        // ✅ CARRIER_NM 변환 함수
        formatDeliveryLocation(carrierNm) {
            if (carrierNm === "AB") return "Plant 1 Warehouse";
            if (carrierNm === "BB") return "Plant 2 Warehouse";
            if (carrierNm === "AD") return "Plant 1 Develop";
            if (carrierNm === "BD") return "Plant 2 Develop";
            if (carrierNm === "ZD") return "Warehouse";
            if (carrierNm === "WB") return "MOBIS RDC";
            return "No data"; // 둘 다 아닐 경우
        },
        formatStatus(status) {
            if (status === '1') return "Shipping";
            if (status === '8') return "Scanning";

            if (status === '9') return "Complete";
            return `${status}`; // 숫자를 문자열로 변환
        },
        async getInvoiceHistory() {
            this.loading = true; // ✅ 로딩 시작
            try {
                //console.log(`📌 Fetching Invoice History for ${this.username}`);

                const response = await axios.get("/api/getInvoiceHistory", {
                    params: { username: this.username },
                });

                // ✅ 응답 데이터 검증
                this.originalData = response.data.invoiceHistory.filter(record => record.CARRIER_NM !== "");
                //console.log(`📌 Filtered Invoice History:`, this.originalData);


                // ✅ 데이터 그룹화 (ASN_NO 기준)
                const groupedData = response.data.invoiceHistory.reduce((acc, record) => {
                    if (!record.CARRIER_NM) return acc;
                    if (!record.PAYER_NM) return acc;
                    if (!acc[record.ASN_NO]) {
                        acc[record.ASN_NO] = {
                            invoiceNo: record.ASN_NO,  // ✅ ASN_NO 사용
                            quantity: 0,  // ✅ 초기값 0
                            issueDate: this.formatDate(record.SHIP_YMD),  // ✅ 날짜 포맷 변경
                            deliveryLocation: this.formatDeliveryLocation(record.CARRIER_NM),  // ✅ CARRIER_NM 변환
                            status: this.formatStatus(record.STATUS_CD), // ✅ 상태 변환
                            deleteVisible: record.STATUS_CD === '1', // ✅ 상태가 1(Shipping)일 때만 삭제 가능
                        };
                    }
                    // ✅ 같은 ASN_NO를 가진 데이터의 ship_qty 합산
                    acc[record.ASN_NO].quantity += record.SHIP_QTY;
                    return acc;
                }, {});

                // ✅ 객체 → 배열 변환
                this.items = Object.values(groupedData);
                this.filteredItems = this.items; // ✅ 여기서 설정해야 함

                //console.log("✅ Invoice history processed:", this.items);
            } catch (error) {
                console.error("❌ API request error:", error);
                this.items = [];
                this.filteredItems = [];
            } finally {
                this.loading = false; // ✅ 로딩 종료
            }
        },
        printInvoice(item) {
            //console.log(`🖨 Printing invoice: ${item.invoiceNo}`);

            // ✅ 해당 invoiceNo를 가진 데이터 찾기
            const invoiceData = this.originalData.filter(record => record.ASN_NO === item.invoiceNo);

            if (invoiceData.length > 0) {
                //console.log("✅ 해당 Invoice 데이터:", invoiceData)
                this.selectedInvoiceData = invoiceData;
                this.showPrintModal = true;
            } else {
                console.warn("⚠ 해당 Invoice 데이터를 찾을 수 없습니다.");
            }
        }, 
        async printPackingList() {
        //console.log("📃 Packing List Print 실행");

        if (!this.selectedInvoiceData || this.selectedInvoiceData.length === 0) {
            console.error("❌ 선택된 Invoice 데이터 없음");
            return;
        }

        try {
            this.loading = true;

            const response = await axios.get("/api/getInvoiceHistory", {
            params: { username: this.username },
            });

            if (!response.data.success) {
            alert("최신 데이터를 가져오지 못했습니다.");
            return;
            }

            this.originalData = response.data.invoiceHistory;
            const targetAsnNo = this.selectedInvoiceData[0]?.ASN_NO;
            this.selectedInvoiceData = this.originalData.filter(item => item.ASN_NO === targetAsnNo);

            if (this.selectedInvoiceData.length === 0) {
            alert("데이터를 찾을 수 없습니다.");
            return;
            }

            const firstItem = this.selectedInvoiceData[0];

            const requestData = {
            offsetNo: firstItem.ASN_NO,
            destination: firstItem.CARRIER_NM,
            offsetIdx: firstItem.ASN_NO.slice(-3),
            estimatedDate: firstItem.SHIP_YMD,
            contNo: firstItem.ASN_NO,
            supplier: firstItem.CUST_NM,
            custCD: firstItem.CUST_CD,
            categoryPlace: firstItem.BL_NO,
            palQty: this.selectedInvoiceData.reduce((sum, item) => sum + (item.SHIP_QTY || 0), 0),
            tableData: this.selectedInvoiceData.map(item => ({
                ITMNO: item.ITEM_NO.trim().replace(/-/g, "-"),
                ITM_NM: item.ITEM_NM,
                TOTAL_QTY: item.SHIP_QTY,
                BOX_LOT: item.CONT_NO,
                REMARK: ''
            }))
            };
            //console.log("📃 Packing List Print 실행", requestData);

            const pdfResponse = await axios.post("/api/createPdf", requestData, {
            responseType: "blob"
            });

            if (pdfResponse.status === 200) {
            const blob = new Blob([pdfResponse.data], { type: "application/pdf" });
            const fileURL = URL.createObjectURL(blob);

            // ✅ 새 창 열기
            const newWindow = window.open("", "_blank", "width=1200,height=900,left=200,top=100");

            if (newWindow) {
                // ✅ 창 내부에 HTML 직접 주입
                newWindow.document.write(`
                <html>
                    <head>
                    <title>Packing List Preview</title>
                    <style>
                        body {
                        margin: 0;
                        display: flex;
                        flex-direction: column;
                        height: 100vh;
                        }
                        iframe {
                        flex: 1;
                        border: none;
                        width: 100%;
                        }
                        button {
                        padding: 10px 20px;
                        font-size: 16px;
                        font-weight: bold;
                        background-color: #007bff;
                        color: white;
                        border: none;
                        cursor: pointer;
                        margin: 10px;
                        }
                    </style>
                    </head>
                    <body>

                    <iframe src="${fileURL}"></iframe>
                    </body>
                </html>
                `);
            } else {
                alert("팝업 차단으로 인해 새 창을 열 수 없습니다.");
            }
            } else {
            console.error("❌ PDF 생성 실패:", pdfResponse.status);
            }
        } catch (error) {
            console.error("❌ Packing List Print API 호출 실패:", error);
        } finally {
            this.loading = false;
        }
        },
        async deleteInvoice(item) {
            const confirmDelete = confirm(`❗ Are you sure you want to delete ${item.invoiceNo}?`);
            if (!confirmDelete) {
                //console.log("❌ 삭제 취소됨");
                return;
            }

            try {
                this.loading = true;
                //console.log(`🗑️ Deleting invoice: ${item.invoiceNo}`);
                const response = await axios.post("/api/deleteASN_MatPackingInfo", {
                    invoiceNo: item.invoiceNo,
                    CUST_CD : this.username
                });

                if (response.data.success) {
                    //console.log("✅ 삭제 성공:", response.data.message);
                    
                    const matchedData = this.originalData.filter(record => record.ASN_NO === item.invoiceNo);
                    //console.log("📌 삭제할 ASN_NO 전체 데이터:", matchedData);

                    // ✅ deleteCountPODetail API 호출
                    const countResponse = await axios.post("/api/deleteCountPODetail", {
                        data: matchedData
                    });

                    if (countResponse.data.success) {
                        //console.log("✅ B_PO_DETAIL 수량 감소 성공");
                        alert("✅ Deletion has been completed.");
                    } else {
                        console.error("❌ B_PO_DETAIL 수량 감소 실패:", countResponse.data.message);
                        alert(`❌ 수량 감소 실패: ${countResponse.data.message}`);
                    }
                    // ✅ 삭제 후 화면 리프레시
                    await this.getInvoiceHistory();
                } else {
                    console.error("❌ 삭제 실패:", response.data.message);
                    alert(`❌ 삭제 실패: ${response.data.message}`);
                }
            } catch (error) {
                console.error("❌ 삭제 API 호출 실패:", error);
                alert("❌ 삭제 중 오류가 발생했습니다.");
            } finally {
                this.loading = false;
            }
        },


    }
};
</script>

<style scoped>
.lot-input {
  width: 100%;
  padding: 5px;
  text-align: center;
}

.custom-select {
    display: flex;
    align-items: center;
    border: 1px solid #d1d5db;
    background-color: white;
    border-radius: 4px;
    padding: 21px 20px;
    cursor: pointer;
    font-size: 16px;
    width: 27px;
    }
    .custom-label5::after {
    content: "";
    position: absolute;
    left: 125.5vh;
    top: 16.2%;
    transform: translateY(-50%);
    width: 2px;
    height: 4.5%;
    background-color: #d1d5db;
    }
    .custom-label4::after {
    content: "";
    position: absolute;
    left: 92vh;
    top: 16.2%;
    transform: translateY(-50%);
    width: 2px;
    height: 4.5%;
    background-color: #d1d5db;
    }

    .custom-label3::after {
    content: "";
    position: absolute;
    left: 52vh;
    top: 16.2%;
    transform: translateY(-50%);
    width: 2px;
    height: 4.5%;
    background-color: #d1d5db;
    }

.custom-label2::after {
    content: "";
    position: absolute;
    left: 13.2vh;
    top: 16.2%;
    transform: translateY(-50%);
    width: 2px;
    height: 4.5%;
    background-color: #d1d5db;
    }
    .custom-input .v-input__control::before,
    .custom-input .v-input__control::after {
    display: none !important;
    box-shadow: none !important;
    border: none !important;
    }
    .container-input2 {
    display: flex;
    align-items: center;
    border: 1px solid #d1d5db;
    background-color: white;
    border-radius: 4px;
    padding: 12px 15px;
    font-size: 16px;
    width: 240px;
    height: 45px;
    }
.container-input {
    display: flex;
    align-items: center;
    border: 1px solid #d1d5db;
    background-color: white;
    border-radius: 4px;
    padding: 12px 15px;
    font-size: 16px;
    width: 350px;
    height: 45px;
    }
.custom-input {
    flex: 1;
    border: none;
    outline: none;
    background: transparent;
    padding-left: 12px;
}
.custom-input .v-input__control {
    border: none !important;
    box-shadow: none !important;
    background: transparent !important;
    min-height: 0 !important; /* ✅ 불필요한 높이 제거 */
    height: 100% !important;
    }

    /* ✅ 숫자 필드의 기본 스핀 버튼 완전 제거 */
    .custom-input input {
    -moz-appearance: none !important; /* Firefox */
    -webkit-appearance: none !important; /* Chrome, Safari */
    appearance: none !important;
    height: auto !important;
    min-height: unset !important;
    padding: 0 !important;
    text-align: left;
    background: transparent !important; /* ✅ 배경 투명화 */
    border: none !important; /* ✅ 테두리 제거 */
    box-shadow: none !important; /* ✅ 불필요한 박스 제거 */
    }

    /* ✅ Vuetify에서 자동 생성되는 불필요한 UI 요소 제거 */
    .custom-input .v-input__control::before,
    .custom-input .v-input__control::after {
    display: none !important;
    box-shadow: none !important;
    border: none !important;
    }

    /* ✅ v-text-field 내부 입력 필드 정렬 */
    .custom-input .v-input__control {
    display: flex !important;
    align-items: center !important;
    }

    /* ✅ 불필요한 여백 제거 */
    .custom-input input {
    margin: 0 !important;
    padding: 0 !important;
    }

    .custom-select2 {
    display: flex;
    align-items: center;
    border: 1px solid #d1d5db;
    background-color: white;
    border-radius: 4px;
    padding: 12px;
    cursor: pointer;
    font-size: 16px;
    width: 200px;
    height: 46px;
}

.custom-select {
    display: flex;
    align-items: center;
    border: 1px solid #d1d5db;
    background-color: white;
    border-radius: 4px;
    padding: 12px;
    cursor: pointer;
    font-size: 16px;
    width: 350px;
    height: 46px;
}

.custom-label2 {
    font-weight: 500;
    color: #6b7280;
    margin-right: 8px;
}
.custom-label3 {
    font-weight: 500;
    color: #6b7280;
    margin-right: 8px;
}
.custom-label4 {
    font-weight: 500;
    color: #6b7280;
    margin-right: 8px;
}
.custom-label5 {
    font-weight: 500;
    color: #6b7280;
    margin-right: 8px;
}


:deep() .v-data-table thead th {
    font-weight: bold !important; /* ✅ 헤더 글씨 굵게 */
    font-size: 14px !important; /* ✅ 글자 크기 */
    text-align: center !important; /* ✅ 중앙 정렬 */
}

.icon-btn {
    min-width: unset !important;  /* 기본 크기 해제 */
    box-shadow: none !important;  /* 그림자 제거 */
    padding: 0 !important;  /* 패딩 제거 */
}

/* ✅ 아이콘 크기 조절 */
.icon-btn v-icon {
    font-size: 10px !important; /* 아이콘 크기 */
}

.custom-card {
    max-width: 100%;  /* 원하는 최대 너비 */
    max-height: 1000px;
    margin: 0 auto;  /* 가운데 정렬 */
}

/* ✅ 테이블 높이 조절 */
.custom-table {
    max-height: 900px;  /* 테이블 최대 높이 */
    overflow-y: auto;  /* 내용이 넘치면 스크롤 */
    margin-top: 10px;
}

.custom-width {
    max-width: 300px;
}

/* 배경색 적용 */
.custom-bg ::v-deep(.v-input__control) {
    background-color: rgb(255, 255, 255) !important;
}


.spinner {
    border: 4px solid rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    border-top: 4px solid black;
    width: 40px;
    height: 40px;
    z-index: 9999;
    animation: spin 1s linear infinite;
}

.data-table-row:hover {
    background-color: #f5f5f5;
    cursor: pointer;
}

:deep() .v-table .v-table__wrapper > table > thead > tr > th {
    border: thin solid rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}
:deep() .v-table .v-table__wrapper > table > tbody > tr > td {
    border: thin solid rgba(var(--v-border-color), var(--v-border-opacity));
}

.custom-text-h4 {
        font-size: 3rem !important;
        font-weight: 400;
        line-height: 2.5rem;
        text-transform: none !important;
    }

    :deep() .v-table thead th {
    font-weight: bold !important; /* 헤더 글씨 굵게 */
    font-size: 14px !important; /* 글자 크기 */
    text-align: center !important; /* 중앙 정렬 */
    background-color: #e3f2fd !important; /* 연한 배경색 추가 */
    color: #333 !important;
}



/* ✅ 테이블 행 마우스 오버 효과 */
:deep() .v-table tbody tr:hover {
    background-color: #f5f5f5 !important; /* 연한 회색 배경 */
    cursor: pointer;
}

.print-btn {
  width: 100px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 16px;
  cursor: pointer;
  overflow: hidden;
  font-weight: 500;
  transition: all 0.3s;
  margin: 5.5px auto;
}
.printer-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: transparent; 
  width: 20px;
  height: 100%;
}
.printer-container {
  height: 50%;
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.printer-container svg {
  width: 100%;
  height: auto;
  transform: translateY(4px);
}
.printer-page-wrapper {
  width: 100%;
  height: 50%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
.printer-page {
  width: 70%;
  height: 10px;
  border: 1px solid black;
  background-color: white;
  transform: translateY(0px);
  transition: all 0.3s;
  transform-origin: top;
}
.print-btn:hover .printer-page {
  height: 16px;
  background-color: rgb(239, 239, 239);
}
.print-btn:hover {
  background-color: rgb(239, 239, 239);
}
/* ✅ 특정 열(Invoice No)의 너비 조정 */
:deep() .v-data-table tbody td:nth-child(1), 
:deep() .v-data-table thead th:nth-child(1) {
    width: 400px !important; /* 첫 번째 열(Invoice No) */
    text-align: center;
}
:deep() .v-data-table tbody td:nth-child(2), 
:deep() .v-data-table thead th:nth-child(2) {
    width: 300px !important; /* 첫 번째 열(Invoice No) */
    text-align: center;
}
:deep() .v-data-table tbody td:nth-child(3), 
:deep() .v-data-table thead th:nth-child(3) {
    width: 300px !important; /* 첫 번째 열(Invoice No) */
    text-align: center;
}
:deep() .v-data-table tbody td:nth-child(4), 
:deep() .v-data-table thead th:nth-child(4) {
    width: 300px !important; /* 첫 번째 열(Invoice No) */
    text-align: center;
}
:deep() .v-data-table tbody td:nth-child(5), 
:deep() .v-data-table thead th:nth-child(5) {
    width: 300px !important; /* 첫 번째 열(Invoice No) */
    text-align: center;
}
:deep() .v-data-table tbody td:nth-child(6), 
:deep() .v-data-table thead th:nth-child(6) {
    width: 110px !important; /* 첫 번째 열(Invoice No) */
    text-align: center;
}
:deep() .v-data-table tbody td:nth-child(7), 
:deep() .v-data-table thead th:nth-child(7) {
    width: 110px !important; /* 첫 번째 열(Invoice No) */
    text-align: center;
}


.bin-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 55px;
  height: 55px;
  border-radius: 50%;
  cursor: pointer;
  transition-duration: 0.3s;
  position: relative;
  overflow: hidden;
  margin: 1px auto;
}
.bin-bottom {
  width: 15px;
  z-index: 2;
}
.bin-top {
  width: 17px;
  transform-origin: right;
  transition-duration: 0.3s;
  z-index: 2;
}
.bin-button:hover .bin-top {
  transform: rotate(45deg);
}

.bin-button:active {
  transform: scale(0.9);
}
.garbage {
  position: absolute;
  width: 14px;
  height: auto;
  z-index: 1;
  opacity: 0;
  transition: all 0.3s;
}
.bin-button:hover .garbage {
  animation: throw 0.4s linear;
}
@keyframes throw {
  from {
    transform: translate(-400%, -700%);
    opacity: 0;
  }
  to {
    transform: translate(0%, 0%);
    opacity: 1;
  }
}
:deep() .v-data-table thead th {
  font-size: 18px !important; /* 헤더 텍스트 크기 증가 */
  font-weight: bold !important;
}

:deep() .v-data-table tbody td {
  font-size: 16px !important; /* 본문 텍스트 크기 증가 */
  font-weight: 500;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.9);
  z-index: 9999;
}
.loading-container {
  display: flex;
  align-items: center;
  gap: 15px; /* 스피너와 텍스트 간격 */
}

/* ✅ 빙글빙글 도는 스피너 */
.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid rgba(0, 123, 255, 0.3);
  border-top: 5px solid #007bff;
  border-radius: 50%;
  animation: spin 2s linear infinite;
}

/* ✅ 스피너 애니메이션 */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/* ✅ 출렁이는 색상 변화 효과 */
.loading-text {
  font-size: 64px;
  font-weight: bold;
  text-transform: uppercase;
  background: linear-gradient(120deg, #ffffff, #007bff, #ffffff);
  background-size: 200% 200%;
  -webkit-background-clip: text;
  color: transparent;
  animation: waveColor 3s ease-in-out infinite;
}

/* ✅ 출렁이는 애니메이션 */
@keyframes waveColor {
  0% {
    background-position: 0% 70%;
  }
  50% {
    background-position: 100% 30%;
  }
  100% {
    background-position: 0% 70%;
  }
}

.lot-input2 {
  width: 100%;
  padding: 6px;
  text-align: center;
  font-weight: bold;
  font-size: 15px;
  border: 2px solid #1976d2; /* 파란 테두리 */
  border-radius: 6px;
  background-color: #e3f2fd; /* 연한 파란 배경 */
  box-shadow: inset 0 1px 3px rgba(0,0,0,0.1); /* 안쪽 그림자 */
}
@font-face {
    font-family: 'HyundaiSans2';
    src: url('../../assets/fonts/HyundaiSansHeadKRMedium.woff2') format('woff2');
    font-weight: normal;
    font-style: normal;
}
@font-face {
    font-family: 'HyundaiSans';
    src: url('../../assets/fonts/HYUNDAISANSHEADKRREGULAR.TTF') format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSans';
    src: url('../../assets/fonts/HYUNDAISANSHEADKRBOLD.TTF') format('truetype');
    font-weight: bold;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSans';
    src: url('../../assets/fonts/HYUNDAISANSHEADKRMEDIUM.TTF') format('truetype');
    font-weight: 500;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSans';
    src: url('../../assets/fonts/HYUNDAISANSHEADKRLIGHT.TTF') format('truetype');
    font-weight: 300;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSansText';
    src: url('../../assets/fonts/HYUNDAISANSTEXTKRREGULAR.TTF') format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSansText';
    src: url('../../assets/fonts/HYUNDAISANSTEXTKRMEDIUM.TTF') format('truetype');
    font-weight: 500;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSansText';
    src: url('../../assets/fonts/HYUNDAISANSTEXTKRBOLD.TTF') format('truetype');
    font-weight: bold;
    font-style: normal;
}

@font-face {
    font-family: 'hyundai2';
    src: url('../../assets/fonts/hundai-M.ttf') format('truetype');
    font-weight: bold;
    font-style: normal;
}
@font-face {
    font-family: 'hyundai';
    src: url('../../assets/fonts/hyundai-L.ttf') format('truetype');
    font-style: normal;
}
/* ✅ 전체 애플리케이션의 기본 폰트로 적용 */
* {
    font-family: 'hyundai' !important;
}

.packing-preview-dialog >>> .v-card {
  max-height: 90vh;
  height: 90vh;
}

.split-box {
  display: flex;
  width: 40vh;
  height: 45px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  overflow: hidden; /* 둥근 모서리 유지 */
  font-size: 16px;
}

.split-box2 {
  display: flex;
  width: 28vh;
  height: 45px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  overflow: hidden; /* 둥근 모서리 유지 */
  font-size: 16px;
}

.split-box3 {
  margin-left: 2vh;
  display: flex;
  width: 40vh;
  height: 45px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  overflow: hidden; /* 둥근 모서리 유지 */
  font-size: 16px;
}

.split-box4 {
  margin-left: 2vh;
  display: flex;
  width: 20vh;
  height: 45px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  overflow: hidden; /* 둥근 모서리 유지 */
  font-size: 16px;
}

.label-box {
  background-color: #f4f4f4; /* 🔵 라벨 배경색 */
  padding: 0 16px;
  display: flex;
  align-items: center;
  font-weight: bold;
  color: #374151;
  white-space: nowrap;
  border-right: 1px solid #d1d5db;
}

.select-box {
  flex: 1;
  padding-left: 16px;
  display: flex;
  align-items: center;
  color: #374151;
  font-weight: bold;
  background-color: white;
}
.value-box {
  flex: 1;
  font-weight: bold;
  padding-left: 16px;
  display: flex;
  align-items: center;
  color: #374151;
}

.container-fluid {
  height : 92%;
  overflow-y: auto;
}
:deep() .v-data-table tbody tr:nth-child(even) {
  background-color: #f5f5f5 !important; /* 짝수 행 연한 회색 */
}

:deep() .v-data-table tbody tr:nth-child(odd) {
  background-color: white !important; /* 홀수 행 흰색 */
}

.pallet-label-table table {
  width: 100%;
  table-layout: fixed; /* ✅ 필수: 열 너비를 명확히 나누기 위해 */
}

.pallet-label-table th:nth-child(1),
.pallet-label-table td:nth-child(1) {
  width: 130px;
}
.pallet-label-table th:nth-child(2),
.pallet-label-table td:nth-child(2) {
  width: 220px;
}
.pallet-label-table th:nth-child(3),
.pallet-label-table td:nth-child(3) {
  width: 120px;
}
.pallet-label-table th:nth-child(4),
.pallet-label-table td:nth-child(4) {
  width: 120px;
}
.pallet-label-table th:nth-child(5),
.pallet-label-table td:nth-child(5) {
  width: 120px;
}

.lot-input2[readonly] {
  background-color: #f0f0f0;
  color: #888;
  cursor: not-allowed;
}
.status-shipping {
  color: #ff9800; /* 주황 */
  font-weight: bold;
}

.status-scanning {
  color: #2196f3; /* 파랑 */
  font-weight: bold;
}

.status-complete {
  color: #4caf50; /* 초록 */
  font-weight: bold;
}
</style>
